"use client";
import React, { useContext, useMemo } from "react";
import useRouter from "@stadium/hooks/lib/use-custom-route";
import classnames from "classnames";

import { MobileMenuToggleContext } from "@stadium/ui/src/contexts/mobile-menu-toggle";
import { LinkButton } from "@stadium/shared/src/components/shared/button";

import { replaceOrigin } from "@stadium/helpers/src/links";

import { MY_SHOPS_TEXT } from "@stadium/shared/src/helpers/sender";

import defaultStyles from "./main.module.scss";

const emptyObj = {};

const HeaderLink = ({
  url = "",
  urlText = "",
  className = "",
  activeClassName = "",
  styles = defaultStyles,
  renderPillTag = () => {},
  additionalInfo = null,
  isExtLink = false,
  onClick,
  ...rest
}) => {
  const { setIsMobileNavOpen } = useContext(MobileMenuToggleContext);
  let asPath = window.location.href;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    asPath = useRouter().asPath; // we have to do this for snackmagic app -- since nextjs router is not mounted
  } catch {}
  const isActive = useMemo(() => {
    const urlHref = new URL(url, window?.location.origin).href;
    const { origin = "", pathname = "", hash = "" } = window?.location || emptyObj;
    const locationHref = origin + pathname + hash;
    return urlHref === locationHref;
  }, [asPath, url]);

  const renderAdditionalInfo = () =>
    urlText === MY_SHOPS_TEXT && additionalInfo && <span>({additionalInfo})</span>;

  const currentUrl =
    !isExtLink && typeof window !== "undefined" && window.location.hostname === "localhost"
      ? replaceOrigin({ url })
      : url;
  return (
    <LinkButton
      href={currentUrl}
      onClick={(e) => {
        setIsMobileNavOpen(false);
        onClick?.(e);
      }}
      className={classnames(className, styles.headerContentLink, {
        [styles.selectedActiveLink]: isActive,
        [activeClassName]: isActive,
      })}
      rel="noopener"
      target={isExtLink ? "_blank" : ""}
      styleType="no-style"
      displayChildren={false}
      {...rest}
    >
      {urlText} {renderAdditionalInfo()} {renderPillTag()}
    </LinkButton>
  );
};

export default HeaderLink;
